import React from 'react'
import { Modal } from '../../ui/Modal/Modal.jsx'
import { resolveKindComponent } from './kinds/resolveKind.js'

/**
 * CardEditor — S07 focused-card-edit modal.
 *
 * Opens when the user clicks into a card from the prep canvas. Renders the
 * full card kind component in a modal container so the user can focus on a
 * single card without the grid context. State is owned by the parent
 * (PrepCanvasPage) and threaded in via `value` / `onChange`.
 *
 * Phase E. Manager view: card is read-only when `disabled` is true.
 */
export function CardEditor({ open, onClose, card, value, onChange, disabled, ownerUserId, activeGoals }) {
  if (!card) return null

  const Component = resolveKindComponent(card.kind)

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={card.kind}
      width="md"
      aria-label={`Edit card: ${card.kind}`}
    >
      <div style={styles.body}>
        {Component ? (
          <Component
            card={card}
            value={value}
            onChange={onChange}
            disabled={disabled}
            ownerUserId={ownerUserId}
            activeGoals={activeGoals ?? []}
          />
        ) : (
          <p style={styles.unknown}>Unknown card kind: {card.kind}</p>
        )}
      </div>
    </Modal>
  )
}

const styles = {
  body: { padding: 0 },
  unknown: { padding: '16px', color: 'var(--color-text-muted)', fontSize: 13 },
}
